import { FieldMap } from '../../../types/forms/fields'
import { chiefComplaintField } from './shared'
export const encounterExamField: FieldMap = {
  name: 'Encounter',
  children: {
    chiefComplaint: chiefComplaintField,
  },
}
